import BaseAuthProvider from './BaseAuthProvider'
import {AuthProviders} from '@/domain/login/constant/authProviders'

/**
 * Email + Token authentication provider
 * Two-step auth: send token to email, then verify with code
 */
export default class EmailTokenAuthProvider extends BaseAuthProvider {
    /**
     * Authenticate with email and token
     * @param {Object} credentials - {email, token}
     * @returns {Promise<Object>} {token, type: 'Token', jwt}
     */
    async authenticate(credentials) {
        const {email, token} = credentials

        const result = await this.service.loginWithToken(email, token)

        return {
            token: result.token,
            type: 'Token',
            jwt: result.jwt
        }
    }

    /**
     * Send login token to user's email
     * @param {string} email
     * @returns {Promise<void>}
     */
    async sendToken(email) {
        return await this.service.sendLoginToken(email)
    }

    async logout(tokenData) {
        // Email token auth doesn't need server-side logout
    }

    supportsRefresh() {
        return false
    }

    getMethod() {
        return AuthProviders.EMAIL_TOKEN
    }

    /**
     * Email Token alternative: password (if enabled)
     */
    getAlternatives(isEnabled) {
        const alternatives = []
        if (isEnabled(AuthProviders.PASSWORD)) {
            alternatives.push(AuthProviders.PASSWORD)
        }
        return alternatives
    }
}
